
import React, { useEffect, useRef, useCallback, useMemo } from 'react';
import TreeView from 'devextreme-react/tree-view';
import { navigation, navigationNoConsultazione, navigationNoConsultazioneNoDoc, navigationNoDoc, navigationNoLet, navigationNoLetNoDoc, navigationNoRee, navigationNoReeNoDoc, navigationActor, navigationActorNoDoc, navigationActorNoDocNoMobile, navigationActorNoMobile, navigationAmm, navigationAmmNoMobile, navigationAmmNoRee, navigationAmmNoReeNoMobile, navigationAmmNoReeNoDocNoMobile, navigationAmmNoLetNoMobile, navigationAmmNoLetNoDocNoMobile, navigationAmmNoConsultazioneNoDocNoMobile, navigationAmmNoDocNoMobile, navigationAmmNoReeNoDoc, navigationAmmNoLet, navigationAmmNoLetNoDoc, navigationAmmNoConsultazione, navigationAmmNoConsultazioneNoMobile, navigationAmmNoConsultazioneNoDoc, navigationAmmNoDoc, navigationUtenti, navigationCallCenter } from '../../app-navigation';
import { useNavigation } from '../../contexts/navigation';
import { useScreenSize } from '../../utils/media-query';
import './side-navigation-menu.scss';
import { useAuth } from '../../contexts/auth';
import { generateNavigation } from '../../app-navigation.js'
import * as events from 'devextreme/events';


export default function SideNavigation(props) {

    const { user } = useAuth();

    const {
        children,
        selectedItemChanged,
        openMenu,
        compactMode,
        onMenuReady
    } = props;
        
    const { isLarge } = useScreenSize();

    function normalizePath() {

        const navigationCallCenter = generateNavigation(user);

        return navigationCallCenter.map((item) => {
            if (item.path && !(/^\//.test(item.path))) {
                item.path = `/${item.path}`;
            }
            return { ...item, expanded: isLarge };
        });
    }


    const items = useMemo(
        normalizePath,
        [normalizePath]
    );

    const { navigationData: { currentPath } } = useNavigation();

    const treeViewRef = useRef();
    const wrapperRef = useRef();
    const getWrapperRef = useCallback((element) => {
        const prevElement = wrapperRef.current;
        if (prevElement) {
            events.off(prevElement, 'dxclick');
        }

        wrapperRef.current = element;
        events.on(element, 'dxclick', e => {
            openMenu(e);
        });
    }, [openMenu]);

    useEffect(() => {
        const treeView = treeViewRef.current && treeViewRef.current.instance;
        if (!treeView) {
            return;
        }

        if (currentPath !== undefined) {
            treeView.selectItem(currentPath);
            treeView.expandItem(currentPath);
        }

        if (compactMode) {
            treeView.collapseAll();
        }
    }, [currentPath, compactMode]);

    return (
        <div
            className={'dx-swatch-additional side-navigation-menu'}
            ref={getWrapperRef}
        >
            {children}
            <div className={'menu-container'}>
                <TreeView
                    ref={treeViewRef}
                    items={items}
                    keyExpr={'path'}
                    selectionMode={'single'}
                    focusStateEnabled={false}
                    expandEvent={'click'}
                    onItemClick={selectedItemChanged}
                    onContentReady={onMenuReady}
                    width={'100%'}
                />
            </div>
        </div>
    );
}
